module.exports = __webpack_public_path__ + "static/chat-agent-1a68a0adbec62818f8d8df990c65fa09.png";